import { Entity } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';

import { ProjectUserRoles } from './ProjectUserRoles';

export interface UpdateProjectUserProps {
  role?: ProjectUserRoles;
}

export interface ProjectUserProps {
  email: string;
  first_name?: string;
  last_name?: string;
  role: ProjectUserRoles;
  avatar_url?: string;
  validated: boolean;
  deleted: boolean;
  created_at: Date;
}

export class ProjectUser extends Entity<ProjectUserProps> {
  get id(): string {
    return this._id!;
  }
  get email(): string {
    return this.props.email;
  }
  get first_name(): string | undefined {
    return this.props.first_name;
  }
  get last_name(): string | undefined {
    return this.props.last_name;
  }
  get role(): ProjectUserRoles {
    return this.props.role;
  }
  set role(role: ProjectUserRoles) {
    this.props.role = role;
  }
  get avatar_url(): string | undefined {
    return this.props.avatar_url;
  }
  get validated(): boolean {
    return this.props.validated;
  }
  get created_at(): Date {
    return this.props.created_at;
  }
  get deleted(): boolean {
    return this.props.deleted;
  }
  protected constructor(props: ProjectUserProps, id?: string) {
    super(props, id);
  }

  update(props: UpdateProjectUserProps) {
    removeEmpty(props);
    if (props.role) this.role = props.role;
  }

  static create(props: ProjectUserProps, id?: string) {
    return new ProjectUser(props, id);
  }
}
